
export class Role {
    isActive: boolean | undefined;
    createdBy: string | undefined;
    modifiedBy: string | undefined;
    id: number = 0;
    name: string | undefined;
    description: string | undefined;

}